module.exports = __webpack_public_path__ + "img/dash-box-arrow-white.c499b75e.svg";